import { Link } from 'react-router'
import { cn } from '~/shared/lib/cn'
import { Tooltip } from '~/shared/ui/local-tooltip'
import { Text } from '~/shared/ui/text'

export function StepLabel({
  label,
  route,
  active,
  lockedReason,
}: {
  label: string
  route?: string
  active?: boolean
  lockedReason?: string
}) {
  if (route) {
    return (
      <Link to={route}>
        <Text
          className="text-text-tertiary underline"
          appearance="BODY2"
        >
          {label}
        </Text>
      </Link>
    )
  }

  const text = (
    <Text
      className={cn({
        'text-text-secondary': !active,
      })}
      appearance="BODY2"
    >
      {label}
    </Text>
  )

  if (lockedReason) {
    return (
      <Tooltip content={lockedReason}>
        <span>{text}</span>
      </Tooltip>
    )
  }

  return text
}
